import { ReactNode } from "react";
import styled from "@emotion/styled";
import { HeaderComponent } from "components/Header";
import { Footer } from "components/Footer";

// Styled Components
const LayoutWrapper = styled.div`
  min-height: 100vh;
  background: ${(props) => props.theme.colors.background};
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  /* Ensure strict scroll boundaries */
  overflow-x: hidden;
  //overscroll-behavior: none;
`;

const Main = styled.main`
  padding-top: 100px; /* Add padding to account for fixed header */
  min-height: calc(100vh - 100px);
  container-type: inline-size;
`;

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  return (
    <LayoutWrapper>
      <HeaderComponent />
      <Main>{children}</Main>
      <Footer />
    </LayoutWrapper>
  );
}

export default Layout;
